import { SuggestUsernameInput } from "~/types/user/user.types";

import { sendRequest } from "../clients/axios";

export const suggestUsername = async (input: SuggestUsernameInput) => {
  const { firstname, lastname } = input;
  const res = await sendRequest<never, string>({
    method: "get",
    url: `/auth/suggest-username?firstname=${firstname}&lastname=${lastname}`,
  });
  return { success: true, data: res.data };
};
